/* global axios */
import ApiClient from './ApiClient';

class InternalChatAPI extends ApiClient {
  constructor() {
    super('internal_chat_rooms', { accountScoped: true });
  }

  getRooms() {
    return this.get();
  }

  getRoom(roomId) {
    return this.show(roomId);
  }

  sendMessage(roomId, content) {
    return axios.post(`${this.url}/${roomId}/internal_chat_messages`, {
      message: { content },
    });
  }

  markRead(roomId) {
    return axios.post(`${this.url}/${roomId}/mark_read`);
  }

  startPrivateConversation(roomId, userId) {
    return axios.post(`${this.url}/${roomId}/private_conversation`, {
      user_id: userId,
    });
  }
}

export default new InternalChatAPI();
